import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap"
import { useHistory } from "react-router-dom"
import { deleteUser, statusChange, GeneratePassword } from "store/actions"
import ViewModal_user_admin from "constants/ViewModal_user_admin"
import ConfirmationModal from "components/Common/ConfirmationModal";
import alert from "./../assets/images/svg/alert.svg";
import password from "./../assets/images/svg/key.svg";
import check from "./../assets/images/svg/check.svg";
import { filterData } from "constants/ShowClientCodeAndRole";
import changePass from '../assets/images/svg/change_password.svg';

const Cards = props => {
  const { user, client } = props
  const [modal, setModal] = useState(false);
  const [modal_backdrop, setModal_backdrop] = useState(false);//delete user purpose don't delete this usestate
  const [status, setStatus] = useState();
  const [statusModal, setStatusModal] = useState(false);
  const [generatePasswordModal, setGeneratePasswordModal] = useState(false);
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    if (user.active === true) {
      setStatus(false)
    } else if (user.active === false) {
      setStatus(true)
    }
  }, [user])
  const { roles, account, gpass } = useSelector(state => ({
    roles: state.GetAdminRoles.roles,
    account: state.changeStatus,
    gpass: state.GeneratePasswordReducer
  }))

  useEffect(() => {
    if (gpass.success.status === "SUCCESS") {
      setGeneratePasswordModal(false);
    }
  }, [gpass])

  useEffect(() => {
    if (account.success.status === "success") {
      setStatusModal(false);
    }
  }, [account])

  return (
    <React.Fragment>
      <Col className="">
        <Card className={`text-center user-details avatar ${status ? "deactive" : "active"}`}>
          <CardBody>
            {/* <div className={`account-status ${status ? 'in-active' : 'active'}`}>
              <p>{status ? "In-Active" : 'Active'}</p>
            </div> */}
            <div className="user-info">


              {user ? (
                <div className={`avatar ${status ? "deactive" : "active"}`}>
                  {!user.profileImg ? (
                    <div className="avatar-sm-lg mx-auto">
                      <span
                        className={
                          "border-line avatar-title rounded-circle bg-soft" +
                          user.color +
                          " text-" +
                          user.color +
                          " font-size-24"
                        }
                      >
                        {user?.firstName.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  ) : (
                    <div className="avatar-sm-lg profile-image rounded-circle border-line">
                      <img
                        className="rounded-circle avatar-title"
                        src={user?.profileImg}
                        alt=""
                      />
                    </div>
                  )}
                </div>
              ) : ""}
              <div className="user-bio">
                <h5 className="font-size-17 mb-0 fw-600">
                  <Link to="#" className="text-dark">
                    {user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1)}
                  </Link>
                </h5>
                <p className="text-muted mb-1 font-size-12 email-field" id={`email-${user._id}`}>
                  {user.email}
                  <UncontrolledTooltip placement="top" target={`email-${user._id}`}>
                    {user.email}
                  </UncontrolledTooltip>
                </p>
                <p className="badge badge-pill mb-0 font-size-13 py-2 px-3 badge-pill-role" id={`badge-${user._id}`}
                >
                  <span>

                    {user?.clientCode ?
                      filterData(client, 'value', user?.clientCode, "label") :
                      filterData(roles, 'value', user?.role, 'label')}
                    <UncontrolledTooltip placement="top" target={`badge-${user._id}`}>
                      {user?.clientCode ?
                        filterData(client, 'value', user?.clientCode, "label") :
                        filterData(roles, 'value', user?.role, 'label')}
                    </UncontrolledTooltip>
                  </span>
                </p>

              </div>
            </div>
          </CardBody>

          <CardFooter className="bg-transparent border-top">
            <div className="admin-card-footer">
              <Link to={user.clientCode ?
                `/users/update-user/${user._id}` :
                `/admin/update-admin/${user._id}`}
                id={"Edit"}
              >
                <i className="bx bx-edit-alt"></i>
                <UncontrolledTooltip placement="top" target={"Edit"}>
                  Click to edit
                </UncontrolledTooltip>
              </Link>
              <Link to={`#`} id={"view"} onClick={() => setModal(!modal)}>
                <i className="mdi mdi-eye" />
                <UncontrolledTooltip placement="top" target={"view"}>
                  Click to view
                </UncontrolledTooltip>
              </Link>

              {
                !status ?
                  <Link to={`#`} id={`generate-${user._id}`}
                    onClick={() => {
                      setGeneratePasswordModal(true)
                    }}>
                    <img src={changePass} />
                    {/* <i className={`mdi mdi-lock-open-alert`} /> */}
                    <UncontrolledTooltip placement="top" target={`generate-${user._id}`}>
                      Click to generate a new password
                    </UncontrolledTooltip>
                  </Link> : null
              }

              {/* do not delete this code it will be need in future */}

              {/** for user list only show delete icon */}
              {/* {(document.title.toLowerCase().includes('user')) ?
                <Link to={`#`} id={"delete"} onClick={() => setModal_backdrop(!modal_backdrop)}>
                  <i className="mdi mdi-trash-can-outline" />
                  <UncontrolledTooltip placement="top" target={"delete"}>
                    Click to delete
                  </UncontrolledTooltip>
                </Link>
                : null} */}

              <Link to={`#`} id={`Status${user._id}`} onClick={() => {
                setStatusModal(true)
              }}>
                <i className={`bx ${status ? 'bx-lock' : 'bx-lock-open'}`} />
                {/* <i className={`mdi mdi-account-${status ? 'check' : 'cancel'}-outline`} /> */}
                <UncontrolledTooltip placement="top" target={`Status${user._id}`}>
                  {status ? 'Click to activate' : 'Click to de-activate'}
                </UncontrolledTooltip>
              </Link>
            </div>

            {/* Modals */}

            {/* view admins/users Modal*/}
            <ViewModal_user_admin modal={modal} setModal={setModal} user={user} client={client} roles={roles} />
            {/* Activate / De-Activate pop-up for confirmation Modal*/}
            <ConfirmationModal
              okButton={() => {
                const id = user._id
                const url = user.clientCode ? `users` : `admin`
                dispatch(statusChange(status, history, id, url))
                setStatus(!status)
              }}
              cancelButton={() => {
                setStatusModal(false);
              }}
              title={status ? "Activate" : "Deactivate account"}
              setStatusModal={setStatusModal}
              statusModal={statusModal}
              loader={account.loader}
              icon={status ? check : alert}
              status={status ? "success" : "error"}
              butttonName={status ? "Activate" : "Deactivate"}
              content={<p>Are you sure, do you want to {status ? 'activate' : 'deactivate'} this user "{user.firstName} {user.lastName}"?</p>}
            />
            {/* Generate password modal */}
            <ConfirmationModal
              okButton={() => {
                const id = user._id
                const path = user.clientCode ? 'users' : 'admin'
                dispatch(GeneratePassword(history, id, path))
              }}
              cancelButton={() => {
                setGeneratePasswordModal(false);
              }}
              title="Generate password"
              icon={password}
              loader={gpass.loader}
              status={"success"}
              butttonName={"New Password"}
              setStatusModal={setGeneratePasswordModal}
              statusModal={generatePasswordModal}
              content={<p>Are you sure, do you want to generate password this user "{user.firstName} {user.lastName}"?</p>}
            />
            {/* *Delete Modal     Do not delete */}
            {/* <ConfirmationModal
              okButton={() => {
                const id = user._id
                dispatch(deleteUser(history, id))
                setModal_backdrop(false);
              }}
              cancelButton={() => {
                setModal_backdrop(false);
              }}
              title="Delete"
              setStatusModal={setModal_backdrop}
              statusModal={modal_backdrop}
              content={<p>Are you sure, do you want to delete this user "{user.firstName} {user.lastName}"</p>}
            /> */}
          </CardFooter>
        </Card>
      </Col>
    </React.Fragment>
  )
}

Cards.propTypes = {
  user: PropTypes.object,
}

export default Cards
